import FeatureFlags from '../../constants/FeatureFlags';
import { getCloudinaryImageUrl } from '../ConnectedSummerCampHeader';
import { HeaderSlideConfig } from '../headerV2/HeaderSlide';
import SliderHeader from '../headerV2/SliderHeader';

const displayDatesConfig = {
  FALL_WINTER_CAMPS: {
    startDate: '2024-11-28T08:00:00.000Z',
    endDate: '2024-12-05T07:59:59.000Z',
  },
  FALL_WINTER_CAMPS_WITH_BADGE: {
    startDate: '2024-12-05T08:00:00.000Z',
    endDate: '2025-01-03T07:59:59.000Z',
  },
};

type INTRO_KEY = keyof typeof displayDatesConfig;

const itemsConfig: HeaderSlideConfig[] = [
  {
    bgColor: '#F8C1D9',
    photoUrl: getCloudinaryImageUrl(
      '7edae67f505d9aecaf114dc10989e5eb57dff708_fl12b5.png'
    ),
    photoAltText: '**Joyful Zen Preschool**, Burbank, CA',
    title: 'The most flexible child care when you need it',
    description: 'Reliable, trusted, on-demand child care at your fingertips',
    cta: {
      text: 'Find locations near me',
      action: 'SEARCH',
    },
    decors: [
      {
        href: '#stars',
        x: 50,
        y: 30,
        width: 55,
        height: 55,
        fill: '#FEEB73',
      },
      {
        href: '#star',
        x: 450,
        y: 305,
        width: 120,
        height: 127,
        fill: '#D0E5CC',
      },
    ],
  },
  {
    bgColor: '#D0E5CC',
    title: 'Infant & Toddler Care',
    description:
      'Your family deserves flexibility. Bumo offers both on-demand and regular care options for your infants and toddlers, exactly when you need it.',
    photoUrl: getCloudinaryImageUrl(
      'bfd559c56569abe12d3eddc10f1c3151c5c9bd8a_yf3udm.png',
      { g: 'center' }
    ),
    photoAltText: '**Sandbox Nursery**, Culver City, CA',
    cta: {
      text: 'Find locations near me',
      action: 'SEARCH',
    },
    decors: [
      {
        href: '#stars',
        x: 40,
        y: 40,
        width: 55,
        height: 55,
        fill: '#F46234',
      },
      {
        href: '#flower',
        x: 415,
        y: 15,
        fill: '#F5AF76',
        width: 77,
        height: 83,
      },
      {
        href: '#bug',
        x: 370,
        y: 296,
        width: 70,
        height: 74,
        fill: '#6B6DD1',
      },
    ],
  },
  {
    bgColor: '#F5AF76',
    title: 'Drop-In Summer Camps',
    description: `Adventure awaits! From outdoor exploration to STEM, arts and crafts, Bumo's diverse summer camps spark curiosity in every child. Book today.`,
    photoUrl: getCloudinaryImageUrl(
      '5c86ead9614290ccb66dc9b32ac92de3_gi5xqx.png',
      { g: 'center' }
    ),
    photoAltText: '**Hawks Nature Camp**, Multiple Locations, CA',
    cta: {
      text: 'Find summer camps',
      action: 'PAGE_LINK',
      pageLink: 'SUMMER_CAMPS',
    },
    decors: [
      {
        href: '#stars',
        x: 40,
        y: 40,
        width: 55,
        height: 55,
        fill: '#F46234',
      },
      {
        href: '#berry',
        x: 413,
        y: 10,
        width: 108,
        height: 117,
        fill: '#FA3088',
      },
      {
        href: '#palm',
        x: 384,
        y: 299,
        width: 80,
        height: 80,
        fill: '#B6EEAB',
      },
    ],
  },
  {
    bgColor: '#F8C1D9',
    title: `Mother's Day`,
    description: `The Mother's Day gift that counts: the gift of child care`,
    photoUrl: getCloudinaryImageUrl(
      'dece626d8212ff1001a653d40b3443600f7666cf_wkl8um.png'
    ),
    cta: {
      text: 'Give the gift of child care',
      action: 'PAGE_LINK' as const,
      pageLink: 'BUY_GIFT_CARD' as const,
    },
    decors: [
      {
        href: '#big-flower' as const,
        width: 130,
        height: 132,
        x: -20,
        y: -40,
      },
      {
        href: '#big-flower' as const,
        width: 130,
        height: 132,
        x: 360,
        y: 30,
      },
      {
        href: '#big-flower' as const,
        width: 130,
        height: 132,
        x: 460,
        y: 300,
      },
    ],
  },
];

export default function IntroSection() {
  return <SliderHeader itemsConfig={itemsConfig} />;
}

export function getCurrentIntroKey(): INTRO_KEY | null {
  const lsIntroKey =
    typeof window !== 'undefined' && window.localStorage
      ? window.localStorage.getItem('FORCE_INTRO')
      : null;
  if (lsIntroKey && displayDatesConfig[lsIntroKey as INTRO_KEY]) {
    return lsIntroKey as INTRO_KEY;
  }

  const now = new Date();
  const nowISO = now.toISOString();

  const activeCampaingKey = (
    Object.keys(displayDatesConfig) as INTRO_KEY[]
  ).find(
    (key) =>
      displayDatesConfig[key].startDate <= nowISO &&
      displayDatesConfig[key].endDate >= nowISO
  );
  return activeCampaingKey || null;
}
